interface ListViewIconProps {
  fill?: string;
  width?: number;
  height?: number;
  [key: string]: any;
}

const ListViewIcon = (props: ListViewIconProps) => (
  <svg
    width={16}
    height={17}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_25849_65566)">
      <mask
        id="mask0_25849_65566"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={16}
        height={17}
      >
        <rect y={0.5} width={16} height={16} />
      </mask>
      <g mask="url(#mask0_25849_65566)">
        <path
          d="M12.6667 10.5V9.16667H3.33333V10.5H12.6667ZM12.6667 7.83333V6.5H3.33333V7.83333H12.6667ZM12.6667 5.16667V3.83333H3.33333V5.16667H12.6667ZM3.33333 14.5C2.96667 14.5 2.65278 14.3694 2.39167 14.1083C2.13056 13.8472 2 13.5333 2 13.1667V3.83333C2 3.46667 2.13056 3.15278 2.39167 2.89167C2.65278 2.63056 2.96667 2.5 3.33333 2.5H12.6667C13.0333 2.5 13.3472 2.63056 13.6083 2.89167C13.8694 3.15278 14 3.46667 14 3.83333V13.1667C14 13.5333 13.8694 13.8472 13.6083 14.1083C13.3472 14.3694 13.0333 14.5 12.6667 14.5H3.33333ZM12.6667 13.1667V11.8333H3.33333V13.1667H12.6667Z"
          fill={props.fill}
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_25849_65566">
        <rect
          width={16}
          height={16}
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default ListViewIcon;
